import {
  ASSESSMENT_PERIOD_OPEN,
  ASSESSMENT_PERIOD_SURVEY,
  ASSESSMENT_PERIOD_IN_PROGRESS,
  ASSESSMENT_PERIOD_CLOSED,
} from 'areas/assessment-schedule/constants';

/**
 * Get human-readable label for assessment period status
 */
export const getAssessmentStatusLabel = (status: number): string => {
  switch (status) {
    case ASSESSMENT_PERIOD_OPEN:
      return 'Open';
    case ASSESSMENT_PERIOD_SURVEY:
      return 'Survey';
    case ASSESSMENT_PERIOD_IN_PROGRESS:
      return 'In Progress';
    case ASSESSMENT_PERIOD_CLOSED:
      return 'Closed';
    default:
      return 'Unknown';
  }
};

/**
 * Get color for assessment period status
 */
export const getAssessmentStatusColor = (status: number): string => {
  switch (status) {
    case ASSESSMENT_PERIOD_OPEN:
      return '#4CAF50'; // Green
    case ASSESSMENT_PERIOD_SURVEY:
      return '#2196F3'; // Blue
    case ASSESSMENT_PERIOD_IN_PROGRESS:
      return '#FF9800'; // Orange
    case ASSESSMENT_PERIOD_CLOSED:
      return '#9E9E9E'; // Gray
    default:
      return '#757575'; // Dark gray
  }
};
